import { GenericAiWidgetData } from '../../../types'
import { WidgetNode } from '../../'

export class GenericAiWidgetNode extends WidgetNode<GenericAiWidgetData> {
  public getCode(): string | undefined {
    return this.data.code
  }

  public getValue(): string | undefined {
    return this.data.value
  }

  public isEmpty(): boolean {
    return !this.getValue()
  }
}
